module.exports = __webpack_public_path__ + "assets/img/t-2.17d6bf90.gif";